import { Badge, cn } from '@eo/shared';

import { formatHours, utilizationPct } from './helpers';
import type { OwnerRollupCardsProps } from './types';

export function OwnerRollupCards({ rows }: OwnerRollupCardsProps) {
  if (rows.length === 0) {
    return <p className="text-sm text-text-tertiary">No clients in the registry yet.</p>;
  }

  return (
    <div className="flex flex-wrap gap-3">
      {rows.map((row) => {
        const utilization = utilizationPct(row.actual, row.budget);
        return (
          <div
            key={row.ownerUserId ?? 'unassigned'}
            data-testid="owner-rollup-card"
            // Cards share the row rather than sitting in fixed columns: one CFO
            // fills the width, two split it, and past four they wrap.
            className="flex min-w-48 flex-1 flex-col gap-1 rounded-16 border border-border-faint bg-[var(--color-canvas-base)] p-3"
          >
            <p className="truncate text-sm font-semibold text-text-primary">{row.name}</p>
            <p className="text-xs text-text-tertiary">
              {row.clientCount} {row.clientCount === 1 ? 'client' : 'clients'}
            </p>
            <p
              className={cn(
                'text-xl font-semibold tabular-nums',
                utilization > 100 ? 'text-destructive' : 'text-text-primary',
              )}
            >
              {utilization}%
            </p>
            <p className="text-xs tabular-nums text-text-tertiary">
              {formatHours(row.actual)} of {formatHours(row.budget)}
            </p>
            <Badge variant={row.overage > 0 ? 'destructive' : 'outline'} className="w-fit">
              {row.overage > 0 ? `${formatHours(row.overage)} over` : 'On budget'}
            </Badge>
          </div>
        );
      })}
    </div>
  );
}
